import formatNumber from 'helpers/formatNumber';

const filtersString = {
  clearAll: 'Clear All',
  apply: 'Apply',
  cancel: 'Cancel',
  filter: 'Filter',
  dateRange: 'Date Range',
  properties: 'Properties',
  propertiesShowRecords: 'Show records that contain:',
  propertiesAny: 'Any of the selected crop zones',
  propertiesAll: 'All selected crop zones',
  propertiesSelectButton: 'Select Properties',
  propertiesClearButton: 'Clear Selections',
  propertiesEmptyState: 'No crop zones found.',
  propertiesCropZones: (count: number) =>
    `${count} crop zone${count === 1 ? '' : 's'}`,
  propertiesAcreage: (area: number) =>
    formatNumber(area, 'ac', 2) ?? `${area.toFixed(2)} ac`
};
export default filtersString;
